import React, { useContext, useRef } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { decryptText, pbdkf2 } from "../../Utils/OstreonEncryption";
import { useAuth } from "../../Context/AuthContext";
import styles from "./styles/LoginRecoveryKey.module.css";
import { useNavigate } from "react-router-dom";
import config from "../../config";
import { formatDate } from "../../Utils/formatDate";
import { serverLogout } from "../../Utils/serverLogout";
import Info from "../User/Info/info";
import InfoTitle from "../User/Info/InfoTitle";
import { isValidEmail } from "../../Utils/isValidEmail";
import { LanguageContext } from "../../Context/changeLanguageProvider";
import { formattingRedirectionUrl } from "../../Utils/redirectingUrl";

const base_url = config.base_url;

export function LoginSelfRecovery() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
    });
  };

  useEffect(() => {
    scrollToTop();
  }, []);

  const auth = useAuth();
  const [disableLogin, setDisableLogin] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const websiteCurrentLang = useContext(LanguageContext).language;
  const [content, setContent] = useState(
    websiteCurrentLang.content.Login.LoginSelfRecovery
  );
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setContent(websiteCurrentLang.content.Login.LoginSelfRecovery);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);
  const [phase, setPhase] = useState(1);
  const [username, setUsername] = useState("");
  const [recovery_key, setKey] = useState({
    seed1: "",
    seed2: "",
    seed3: "",
    seed4: "",
    seed5: "",
    seed6: "",
    seed7: "",
    seed8: "",
  });
  const [loginError, setLoginError] = useState(null);
  const [id_type, setIDType] = useState();
  const [id_timestamp, setIDTimestamp] = useState();
  const [id_value, setID_value] = useState();
  const inputRefs = useRef([]);
  const [error, setError] = useState({
    email: "",
    key: "",
  });
  // const auth = useAuth()
  // const userData = UserData()
  useEffect(() => {
    // alert (auth?.otp)
    if (auth.otp) {
      serverLogout();
      auth.logout();
    }
  }, [auth]);
  const navigate = useNavigate();
  const changeKey = (seed, value_, index) => {
    console.log(value_);
    const value = value_.toUpperCase();
    const regex = /^([A-Za-z0-9]{4}-){7}[A-Za-z0-9]{4}$/;
    if (regex.test(value)) {
      const parts = value.split("-");
      let joined_key = {
        seed1: "",
        seed2: "",
        seed3: "",
        seed4: "",
        seed5: "",
        seed6: "",
        seed7: "",
        seed8: "",
      };
      parts.map((e, index) => {
        joined_key[`seed${index + 1}`] = e;
        return null;
      });
      setKey(joined_key);
    } else {
      console.log("String does not have correct format");
      if (value.length <= 4) setKey({ ...recovery_key, [seed]: value });
      if (value.length === 4) inputRefs.current[index + 1].focus();
      if (value.length === 0) inputRefs.current[index - 1].focus();
    }
  };
  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://www.google.com/recaptcha/api.js?render=6Ldi00MoAAAAAOhEarj3D8oPKndxNMGHPNVPeciu";
    document.body.appendChild(script);
  }, []);
  const showError = (error) => {
    setLoginError(error);
    setTimeout(() => {
      setLoginError(null);
    }, 3000);
  };
  const getIDData = (token) => {
    fetch(base_url + "login/selfrecovery/data", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
      body: `token=${token}`,
    })
      .then((res) => {
        if (res.status === 429)
          setLoginError(dublicatedcontent.dublicatedText51);
        else if (res.status === 403)
          setLoginError(content.LoginSelfRecoveryEmailError1);
        else if (res.status === 500)
          setLoginError(content.LoginSelfRecoveryGeneralError1);
        else if (res.status === 498)
          setLoginError(dublicatedcontent.dublicatedText49);
        else if (res.status === 404)
          setLoginError(dublicatedcontent.dublicatedText78);
        else return res.json();
      })
      .then((res) => {
        if (!res) return;
        console.log(res);
        setDisableLogin(false);
        setIDTimestamp(res?.timestamp || "");
        setIDType(res?.type || "");
      })
      .catch((e) => {
        setLoginError(content.LoginSelfRecoveryGeneralError3);
      });
  };
  const handleLogin = async (token) => {
    let recovery_key_joined = recovery_key[Object.keys(recovery_key)[0]];
    let keys = Object.keys(recovery_key);
    keys.shift();
    keys.forEach((element) => {
      recovery_key_joined = recovery_key_joined + "-" + recovery_key[element];
    });
    const [pbdkf2hash] = await pbdkf2(
      recovery_key_joined,
      "OSTREON",
      100000,
      32 * 8
    );

    fetch(base_url + "login/selfrecovery", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      body: `username=${username}&self_recovery_key=${pbdkf2hash}&token=${token}`,
      credentials: "include",
    })
      .then((res) => {
        if (res.status === 429)
          throw new Error(content.LoginSelfRecoveryBlockedError1);
        if (res.status === 403)
          throw new Error(content.LoginSelfRecoveryEmailError1);
        if (res.status === 500)
          throw new Error(content.LoginSelfRecoveryGeneralError1);
        if (res.status === 498)
          throw new Error(dublicatedcontent.dublicatedText49);
        else return;
      })
      .then(async (data) => {
        setPhase(2);
        setDisableLogin(false);
        captchaPromise()
          .then((token) => {
            console.log(token);
            getIDData(token);
          })
          .catch((e) => {
            setLoginError(content.LoginSelfRecoveryGeneralError3);
          });
      })
      .catch((err) => {
        console.log(err);
        setLoginError(err.message);
        setTimeout(() => {
          setLoginError(null);
        }, 5000);
      })
      .finally(() => setDisableLogin(false));
  };
  const submitCaptcha = (e) => {
    if (e) e.preventDefault();
    window.grecaptcha.ready(() => {
      setDisableLogin(true);
      window.grecaptcha
        .execute("6Ldi00MoAAAAAOhEarj3D8oPKndxNMGHPNVPeciu")
        .then((token) => {
          const hasEmptyValue = Object.keys(recovery_key).some(
            (key) => recovery_key[key] === ""
          );
          const newErrors = {};

          if (!username) {
            newErrors.email = dublicatedcontent.dublicatedText79;
          }
          if (username && !isValidEmail(username)) {
            newErrors.email = dublicatedcontent.dublicatedText47;
          }
          if (hasEmptyValue) {
            newErrors.key = content.LoginSelfRecoveryKeyError1;
          }

          if (Object.keys(newErrors).length > 0) {
            setError(newErrors);
            setTimeout(() => {
              Object.keys(error).forEach((key) => {
                setError((prevError) => ({ ...prevError, [key]: null }));
              });
            }, 5000);
          } else {
            setDisableLogin(false);
            handleLogin(token);
          }
        })
        .catch((e) => {
          setDisableLogin(false);
        })
        .then(() => {
          setDisableLogin(false);
        });
    });
  };
  const captchaPromise = (e) => {
    return new Promise((resolve, reject) => {
      if (e) e.preventDefault();
      window.grecaptcha.ready(() => {
        setDisableLogin(true);
        window.grecaptcha
          .execute("6Ldi00MoAAAAAOhEarj3D8oPKndxNMGHPNVPeciu")
          .then((token) => {
            resolve(token);
          })
          .catch((e) => {
            console.log(e);
            setDisableLogin(false);
            reject(e);
          });
      });
    });
  };
  const validateID = async (e) => {
    e.preventDefault();
    const [id_value_pbdkf] = await pbdkf2(id_value, "OSTREON", 100000, 32 * 8);
    if (!id_value) return setLoginError(content.LoginSelfRecoveryGeneralError4);
    if (!id_value_pbdkf)
      return setLoginError(content.LoginSelfRecoveryGeneralError5);
    captchaPromise()
      .then((token) => {
        if (!token)
          return setLoginError(content.LoginSelfRecoveryCaptchaError2);
        return fetch(base_url + "login/selfrecovery/id", {
          method: "POST",
          mode: "cors",
          headers: {
            Accept: "application/json, text/plain, */*",
            "Content-type": "application/x-www-form-urlencoded",
            credentials: "include",
          },
          credentials: "include",
          body: `id=${id_value_pbdkf}&token=${token}`,
        });
      })
      .then((res) => {
        if (res.status === 200) return res.json();
        if (res.status === 404)
          throw new Error(content.LoginSelfRecoveryGeneralError6);
        if (res.status === 403)
          throw new Error(
            `${content.LoginSelfRecoveryGeneralError7Text1} ${
              dublicatedcontent[id_type?.toLowerCase()?.replace(" ", "_")]
            } ${content.LoginSelfRecoveryGeneralError7Text2}`
          );
        else throw new Error(content.LoginSelfRecoveryGeneralError7);
      })
      .then((res) => {
        const private_key_self_recovery_id = res.private_key_self_recovery_id;
        decryptText(id_value, private_key_self_recovery_id)
          .then((private_key) => {
            window.sessionStorage.setItem("ostreon_key", private_key);
            auth.login("OK");
            auth.setEmail(username);
            auth.setOTP(true);
            auth.setPWDChange("Self Recovery Access");
            navigate("/user/changepwd", { replace: true });
          })
          .catch((e) => {
            console.log(e);
          });
      })
      .catch((e) => {
        console.log(e.toString());
        if (!e.toString())
          setLoginError(content.LoginSelfRecoveryGeneralError8);
        else setLoginError(e.message);
      })
      .finally(() => {
        setDisableLogin(false);
      });
  };
  const handleEnter = (e) => {
    if (e.key === "Enter") {
      submitCaptcha(e);
    }
  };
  useEffect(() => {
    if (phase === 1) {
      serverLogout();
      return;
    }
    const timeoutId = setTimeout(() => {
      console.log("tooLoong");
      setPhase(1);
      setUsername("");
      setKey({
        seed1: "",
        seed2: "",
        seed3: "",
        seed4: "",
        seed5: "",
        seed6: "",
        seed7: "",
        seed8: "",
      });
    }, 2 * 60 * 1000);

    return () => clearTimeout(timeoutId);
  }, [phase]);
  return (
    <div className={styles.main_div}>
      <div
        className={styles.home_link}
        onClick={() => {
          window.location.href = formattingRedirectionUrl("#");
        }}
      >
        {dublicatedcontent.dublicatedText41}
      </div>

      {phase === 1 && (
        <>
          <div className={styles.title}>{content.LoginSelfRecoveryText1}</div>
          <div className={styles.text}>
            {content.LoginSelfRecoveryText2}{" "}
            <a
              className={styles.blue_link}
              target="_blank"
              href={dublicatedcontent?.intercom_recover_password}
            >
              {dublicatedcontent.dublicatedText68}
            </a>
          </div>
          <div className={styles.main} onKeyDown={handleEnter}>
            <div className={styles.top}>
              <div className={styles.inputs}>
                <div
                  className={`${styles.input_div} ${
                    error?.email ? styles.field_error : ""
                  } ${loginError ? styles.field_error : ""}`}
                >
                  <div className={styles.input_text}>
                    {dublicatedcontent.dublicatedText42}{" "}
                    <Info message={dublicatedcontent.dublicatedText43} />
                  </div>
                  <input
                    autoFocus
                    className={styles.input}
                    value={username}
                    onChange={(e) => {
                      setUsername(e.target.value.toLowerCase());
                    }}
                    placeholder={dublicatedcontent.dublicatedText42}
                  />

                  {error?.email ? (
                    <div className={styles.login_error}>{error.email}</div>
                  ) : null}
                </div>
              </div>

              <div
                className={`${styles.big_field} ${
                  error?.key ? styles.field_error : ""
                }`}
              >
                <div className={styles.recovery_input_title}>
                  {dublicatedcontent?.insert_your_recovery_code}{" "}
                  <Info message={dublicatedcontent.dublicatedText44} />
                </div>
                <div
                  className={`${styles.recovery_key_div} ${
                    loginError ? styles.error_fields : ""
                  }`}
                >
                  {Object.keys(recovery_key).map((seed, index) => {
                    if (index + 1 === Object.keys(recovery_key).length)
                      return (
                        <input
                          ref={(ref) => (inputRefs.current[index] = ref)}
                          onChange={(e) => {
                            changeKey(`${seed}`, e.target.value, index);
                          }}
                          value={recovery_key[seed]}
                          className={styles.recovery_key}
                        ></input>
                      );
                    else
                      return (
                        <>
                          <input
                            ref={(ref) => (inputRefs.current[index] = ref)}
                            onChange={(e) => {
                              changeKey(`${seed}`, e.target.value, index);
                            }}
                            value={recovery_key[seed]}
                            className={styles.recovery_key}
                          ></input>
                        </>
                      );
                  })}
                </div>
                {error?.key ? (
                  <div className={styles.login_error}>{error.key}</div>
                ) : null}
              </div>
              <div className={styles.footer}>
                {loginError ? (
                  <div className={styles.login_error}>{loginError}</div>
                ) : null}
                <button
                  disabled={disableLogin}
                  onClick={(e) => submitCaptcha(e)}
                  className={styles.login_button}
                >
                  {content.LoginSelfRecoveryButton1}
                </button>
                <button
                  onClick={() => navigate("/login", { replace: false })}
                  className={styles.back_to_login}
                >
                  {dublicatedcontent.dublicatedText46}
                </button>
              </div>
            </div>
          </div>
        </>
      )}
      {phase === 2 && (
        <>
          <div className={styles.title}>{content.LoginSelfRecoveryText8}</div>
          <InfoTitle
            message={"..."}
            title={
              localStorage.getItem("language") === "fr"
                ? "Explication"
                : "Explanation"
            }
          />
          <div
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                validateID(e);
              }
            }}
            className={`${styles.main} ${styles.main_small}`}
          >
            <div className={styles.id_main_box}>
              <div className={styles.grey_bold}>
                {content.LoginSelfRecoveryText9}
              </div>
              <div className={styles.grey_small}>
                {content.LoginSelfRecoveryText10}
              </div>
              {id_timestamp && id_type && (
                <div className={styles.grey_medium}>
                  {content.LoginSelfRecoveryText11}{" "}
                  {dublicatedcontent[id_type?.toLowerCase()?.replace(" ", "_")]}{" "}
                  {content.LoginSelfRecoveryText12} {formatDate(id_timestamp)}
                </div>
              )}
              <div
                className={`${styles.input_div} ${
                  loginError ? styles.field_error : ""
                }`}
              >
                <input
                  type={showPassword ? "text" : "password"}
                  onChange={(e) => setID_value(e.target.value)}
                  autoFocus
                  className={`${styles.id_input}`}
                  placeholder={content.LoginSelfRecoveryText13}
                />
                <div
                  onClick={() => {
                    setShowPassword(!showPassword);
                  }}
                  className={styles.password_button}
                >
                  <svg
                    width="18"
                    height="15"
                    viewBox="0 0 18 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.99994 10.2062C7.20744 10.2062 5.75244 8.99375 5.75244 7.5C5.75244 6.00625 7.20744 4.79375 8.99994 4.79375C10.7924 4.79375 12.2474 6.00625 12.2474 7.5C12.2474 8.99375 10.7924 10.2062 8.99994 10.2062ZM8.99994 5.73125C7.82994 5.73125 6.87744 6.525 6.87744 7.5C6.87744 8.475 7.82994 9.26875 8.99994 9.26875C10.1699 9.26875 11.1224 8.475 11.1224 7.5C11.1224 6.525 10.1699 5.73125 8.99994 5.73125Z"
                      fill="#B3B3B3"
                    />
                    <path
                      d="M9.00006 13.1375C6.18006 13.1375 3.51756 11.7625 1.68756 9.375C0.892559 8.34375 0.892559 6.6625 1.68756 5.625C3.52506 3.2375 6.18756 1.8625 9.00006 1.8625C11.8126 1.8625 14.4751 3.2375 16.3051 5.625C17.1001 6.65625 17.1001 8.3375 16.3051 9.375C14.4751 11.7625 11.8126 13.1375 9.00006 13.1375ZM9.00006 2.8C6.57756 2.8 4.26006 4.0125 2.64006 6.13125C2.07756 6.8625 2.07756 8.1375 2.64006 8.86875C4.26006 10.9875 6.57756 12.2 9.00006 12.2C11.4226 12.2 13.7401 10.9875 15.3601 8.86875C15.9226 8.1375 15.9226 6.8625 15.3601 6.13125C13.7401 4.0125 11.4226 2.8 9.00006 2.8Z"
                      fill="#B3B3B3"
                    />
                  </svg>
                </div>
              </div>
              {loginError ? (
                <div className={styles.login_error}>{loginError}</div>
              ) : null}
              <button
                disabled={disableLogin}
                onClick={(e) => validateID(e)}
                className={`${styles.login_button} ${styles.login_button_small}`}
              >
                {dublicatedcontent.dublicatedText3}
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
